import {add} from 'date-fns';
import {match} from 'ts-pattern';

import {always, isNotNil} from 'ramda';

import {GetCustomerPaymentApiResponse} from '@dms/api/finance';
import {AftersalesPaymentMethod, Payment} from '@dms/api/sales';

import {parseDate} from 'shared/web';

import {CheckoutPaymentFormTypeV2} from '../types/CheckoutPaymentFormTypeV2';

interface BuildPaymentFormDefaultValuesParams {
  payment: Payment;
  customerPayment: GetCustomerPaymentApiResponse | undefined;
  defaultPaymentType?: AftersalesPaymentMethod;
  primaryBankAccountValue?: string;
}

export function buildPaymentFormDefaultValues(
  params: BuildPaymentFormDefaultValuesParams
): Partial<CheckoutPaymentFormTypeV2> {
  const {payment, customerPayment, defaultPaymentType, primaryBankAccountValue} = params;

  const defaultPaymentMethod = match<
    [AftersalesPaymentMethod | undefined, boolean],
    AftersalesPaymentMethod | undefined
  >([payment.method ?? defaultPaymentType, !!customerPayment?.allowBankTransfer])
    .with(['BANK_TRANSFER', false], always('CARD'))
    .otherwise(([paymentType]) => paymentType);

  return {
    amount: payment.paymentAmount?.amount ?? undefined,
    bankAccount: payment.bankAccount?.id ?? primaryBankAccountValue ?? undefined,
    note: payment.note ?? undefined,
    method: defaultPaymentMethod,
    due: customerPayment?.invoiceMaturity ?? payment.due ?? 0,
    dueDate: isNotNil(customerPayment?.invoiceMaturity)
      ? add(new Date(), {days: customerPayment?.invoiceMaturity})
      : parseDate(payment.dueDate ?? new Date().toISOString()),
    issueDate: parseDate(payment.issuedOn ?? new Date().toISOString()),
    dateOfTaxableSupply: parseDate(payment.dateOfTaxableSupply ?? new Date().toISOString()),
    currency: payment.foreignCurrencyPaymentAmount?.currency,
    customerServiceContractId: payment.customerServiceContractId ?? undefined,
    templateId: payment.templateId ?? undefined,
    exchangeRate: payment.exchangeRate ? parseFloat(payment.exchangeRate) : undefined,
    correctionReason: payment.correctionDetails?.reason ?? undefined,
    dateOfReception: payment.correctionDetails?.dateOfReception
      ? parseDate(payment.correctionDetails.dateOfReception)
      : undefined,
  };
}
